var exports = {
  "Qs": "KeyboardModeIntroModal.module__content___UlJHeH",
  "h_": "KeyboardModeIntroModal.module__description___UlJHeH",
  "Xq": "KeyboardModeIntroModal.module__tips___UlJHeH",
  "uN": "KeyboardModeIntroModal.module__tip___UlJHeH",
  "HP": "KeyboardModeIntroModal.module__keys___UlJHeH",
  "eS": "KeyboardModeIntroModal.module__kbd___UlJHeH",
  "me": "KeyboardModeIntroModal.module__separator___UlJHeH",
  "xY": "KeyboardModeIntroModal.module__tipText___UlJHeH",
};

module.exports = exports;
